import * as Sentry from '@sentry/browser';
import {defineNuxtPlugin} from 'nuxt/app'
// import { browserTracingIntegration } from '@sentry/browser';


export default defineNuxtPlugin((nuxtApp) => {
    Sentry.init({
        nuxtApp,
      dsn: 'https://6a2619419d9c48b3b15fb12f1fb7b288@sentry.ksi.fit.cvut.cz/15', // replace with your DSN
    //   integrations: [
    //     new browserTracingIntegration(),
    //   ],
      tracesSampleRate: 1.0, // adjust to your needs
    });
    // nuxtApp.vueApp.config.errorHandler = (err, vm, info) => {
    //     Sentry.captureException(new Error(err));
    //     Sentry.captureException(err);
    //     console.error(err);
    //     Sentry.captureMessage(vm);
    //     console.log(vm);
    //     Sentry.captureMessage(info);
    //     console.log(info);
    //   };
    Sentry.captureException(new Error())
    // Sentry.captureMessage('Something went wrong');
})